import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { AgmTokenService } from './agm-token.service';

@Injectable({
  providedIn: 'root',
})

export class AgmAuthStateService {
  private userState = new BehaviorSubject<boolean>(this.token.isLoggedIn()!);
  userAuthState = this.userState.asObservable();
  constructor(public token: AgmTokenService) {}
  setAuthState(value: boolean) {
    this.userState.next(value);
  }
}